import { getRequestCommonParameters } from '@lib/core/service/requests/api';

/**
 * Uses as main URL for different Service Terms request types (GET, PUT, PATH, OPTIONS, POST)
 */
export const apiUrlServiceTerms = () => {
  const { retailerSlug, retailerLocationSlug } = getRequestCommonParameters();
  return `/${retailerSlug}/${retailerLocationSlug}/service-terms/`;
};
